import { create } from 'zustand';
import type { UserRole } from '@popgarden/shared-types';

export type AuthUser = {
  id: string;
  username: string;
  fullName: string;
  role: UserRole;
  projectIds: string[];
};

type AuthState = {
  accessToken: string | null;
  user: AuthUser | null;
  /** False until the silent-refresh bootstrap has run once on app start. */
  bootstrapped: boolean;
  setSession: (accessToken: string, user: AuthUser) => void;
  setAccessToken: (token: string) => void;
  setBootstrapped: (v: boolean) => void;
  clear: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  bootstrapped: false,
  setSession: (accessToken, user) => set({ accessToken, user }),
  setAccessToken: (accessToken) => set({ accessToken }),
  setBootstrapped: (bootstrapped) => set({ bootstrapped }),
  clear: () => set({ accessToken: null, user: null }),
}));
